module.exports = __webpack_public_path__ + "static/template_options_2_week_columns-066181605d784f60af0708582eaeca90.png";